import React from 'react';
import { useScenarios } from '../../hooks/useScenarios';
import { useVisibleScenarios } from '../../hooks/useVisibleScenarios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { formatDate } from '../../lib/utils';
import { Play, Calendar } from 'lucide-react';
import { toast } from 'sonner';

export const ParkedDashboard: React.FC = () => {
  const { reactivateScenario } = useScenarios();
  const scenarios = useVisibleScenarios();
  const parkedScenarios = scenarios.filter(s => s.status === 'parked');

  const handleReactivate = (id: string, name: string) => {
    reactivateScenario(id);
    toast.success(`"${name}" has been reactivated`);
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Parked Scenarios ({parkedScenarios.length})</CardTitle>
        </CardHeader>
        <CardContent>
          {parkedScenarios.length === 0 ? (
            <div className="text-center text-muted-foreground py-8">
              No parked scenarios
            </div>
          ) : (
            <div className="space-y-4">
              {parkedScenarios.map((scenario) => (
                <div key={scenario.id} className="p-4 border rounded-lg">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <h3 className="font-semibold">{scenario.name}</h3>
                        <Badge variant="secondary">Parked</Badge>
                      </div>
                      <p className="text-sm text-muted-foreground mb-3">
                        {scenario.description}
                      </p>
                      {scenario.parkedReason && (
                        <div className="p-3 bg-muted rounded-lg mb-3">
                          <div className="text-sm font-medium mb-1">Reason:</div>
                          <div className="text-sm">{scenario.parkedReason}</div>
                        </div>
                      )}
                      <div className="flex items-center gap-4 text-sm text-muted-foreground">
                        <div>
                          Parked: {scenario.parkedAt && formatDate(scenario.parkedAt)}
                        </div>
                        {scenario.reviewDate && (
                          <div className="flex items-center gap-1">
                            <Calendar className="h-3 w-3" />
                            Review: {formatDate(scenario.reviewDate)}
                          </div>
                        )}
                        <div>
                          By: {scenario.parkedBy}
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-2 ml-4">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleReactivate(scenario.id, scenario.name)}
                      >
                        <Play className="h-4 w-4 mr-2" />
                        Reactivate
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
